import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Label,
  Input,
  textarea,
  Container,
  UncontrolledTooltip,
  Table,
} from "reactstrap";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
// import './CssForAll.css'
import PostApiCall from "../../Api";
import GetApiCall from "../../GETAPI";
import Notiflix from "notiflix";
import moment from "moment";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withNamespaces } from "react-i18next";

class AddClients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newClient: {
        accountNumber: "",
        chitScheme: "",
        chitSchemeType: "",
        chitAmount: "",
        duration: "",
        user: "",
        paidMonths: "",
        title: "",
      },
      clients: [],
      showData: true,
      arrIndex: "",
      editOption: false,
      dropdown: "",
      address: "",
      country: "",
      state: "",
      city: "",
      visiblity: true,
      //personal details
      name: "",
      username: "",
      Email: "",
      Mobile: "",
      landmark: "",
      pin: "",
      PermanentSame: false,
      accValid: "form-control",
      NameValid: "form-control",
      EmailValid: "form-control",
      MobileValid: "form-control",
      chitSchemeValid: "form-control",

      chitAmountValid: "form-control",
      durationValid: "form-control",
      userValid: "form-control",
      paidMonthsValid: "form-control",

      titleValid: "form-control",

      freqentChitfundData: [{ label: "Select Chit Scheme", value: "" }],
      freqentChitfundPriceData: [],
      freqentChitfundPriceData2: [],
      freqentChitfundPriceData3: [],
      freqentChitfundPriceData4: [],
      freqentChitfundPriceData5: [],
      freqentChitfundPriceData6: [],
      freqentChitfundPriceData7: [],
      freqentChitfundPriceData8: [],
      freqentChitfundPriceData9: [],
      freqentChitfundPriceData10: [],
      freqentUserData: [
        { label: "Select User", value: "" },
        { label: "New", value: "New" },
        { label: "Existing", value: "Existing" },
      ],

      freqentMonthData: [
        { label: "Select Months", value: "" },
        { label: "01", value: "01" },
        { label: "02", value: "02" },
        { label: "03", value: "03" },
        { label: "04", value: "04" },
        { label: "05", value: "05" },
        { label: "06", value: "06" },
        { label: "07", value: "07" },
        { label: "08", value: "08" },
        { label: "09", value: "09" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
        { label: "12", value: "12" },
        { label: "13", value: "13" },
        { label: "14", value: "14" },
        { label: "15", value: "15" },
      ],
      freqentMonthData2: [
        { label: "Select Months", value: "" },
        { label: "01", value: "01" },
        { label: "02", value: "02" },
        { label: "03", value: "03" },
        { label: "04", value: "04" },
        { label: "05", value: "05" },
        { label: "06", value: "06" },
        { label: "07", value: "07" },
        { label: "08", value: "08" },
        { label: "09", value: "09" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
      ],

      freqentDurationData: [
        { label: "Select Chit Duration", value: "" },
        { label: "15", value: "15" },
      ],
      freqentDurationData2: [
        { label: "Select Chit Duration", value: "" },
        { label: "11", value: "11" },
      ],
      freqentDurationData3: [
        { label: "Select Chit Duration", value: "" },
        { label: "330", value: "330" },
      ],
      DecimalRegex: /^(\d*\.?\d{0,2}|\.\d{0,9})$/,
      NumRegex: /^[0-9]*$/,

      booknumData: [],
      BookTypeData: [
        { label: "Monthly", value: "Monthly" },
        { label: "Daily", value: "Daily" },
      ],
      booknumData2: [],
      booknumData3: [],
      BookNumbers: "",
      ViewBtn: false,
    };
    this.inputRef = React.createRef();
  }

  componentDidMount = () => {
    var login = localStorage.getItem("LoginDetail");
    var details = JSON.parse(login);
    // console.log(details[0])
    this.setState({
      Usertype: details[0].fld_usertype,
    });
    if (details[0].fld_usertype != "Admin") {
      window.location.href = "/"
    }
    Notiflix.Loading.Init({
      svgColor: "#880105",
    });
  };

  getSchemeData = (data) => {
    PostApiCall.postRequest(
      {
        type: data,
      },
      "Get_Scheme_On_Type"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status == 200 || result.status == 201) {
          if (this.state.newClient.chitSchemeType == "Monthly") {
            this.setState({
              freqentChitfundData: obj.freqentChitfundData,
              booknumData2: obj.booknumData2,
              booknumData: obj.booknumData,
              freqentChitfundPriceData6: obj.freqentChitfundPriceData6,
              freqentChitfundPriceData7: obj.freqentChitfundPriceData7,
              freqentChitfundPriceData8: obj.freqentChitfundPriceData8,
              freqentChitfundPriceData9: obj.freqentChitfundPriceData9,
              freqentChitfundPriceData10: obj.freqentChitfundPriceData10,
            });
          } else {
            this.setState({
              freqentChitfundData: obj.freqentChitfundData,
              booknumData3: obj.booknumData3,
              freqentDurationData: obj.Dauration,
            });
          }
          this.setState({
            freqentChitfundPriceData: obj.freqentChitfundPriceData,
            freqentChitfundPriceData2: obj.freqentChitfundPriceData2,
            freqentChitfundPriceData3: obj.freqentChitfundPriceData3,
            freqentChitfundPriceData4: obj.freqentChitfundPriceData4,
            freqentChitfundPriceData5: obj.freqentChitfundPriceData5,
          });
          // window.location.reload();
        } else {
          Notiflix.Notify.Failure(obj.data);
        }
      })
    );
  };

  handleUserInput = (e) => {
    if (e.target.name === "exiting_user" && e.target.value === "Existing") {
      this.setState({
        visiblity: false,
      });
    } else {
      this.setState({
        visiblity: true,
      });
    }

    let input_data = Object.assign({}, this.state.newClient);

    const fields = e.target.id;
    input_data[fields] = e.target.value;

    this.setState({
      newClient: input_data,
      userValid: "form-control is-valid",
    });

    if (e.target.value === "") {
      this.setState({
        userValid: "form-control is-invalid",
      });
    }
  };

  handleChitScheme = (text) => {
    let input_data = Object.assign({}, this.state.newClient);

    const fields = text.target.id;

    input_data[fields] = text.target.value;

    // console.log(text.target.value);
    this.setState({
      chitSchemeValid: "form-control is-valid",
      newClient: input_data,
    });
    //   console.log(this.state.newClient.chitScheme);

    if (text.target.value === "") {
      this.setState({
        chitSchemeValid: "form-control is-invalid",
      });
    }
  };

  // handleBooknumber = (e) => {

  //     this.setState({
  //         newClient: {
  //         title:e.target.value
  //         }
  //     })

  //     // let input_data2 = Object.assign({}, this.state.newClient);

  //     // const fields = e.target.id;
  //     // console.log(fields)
  //     // input_data2[fields] = e.target.value;
  //     // console.log(input_data2)
  //     // console.log(e.target.value);
  //     // this.setState({
  //     //     bookNumberValid: "form-control is-valid",
  //     //     title: input_data2
  //     // })
  //     // console.log(input_data2)
  //     // console.log(e.target.value)
  //     //   console.log(this.state.newClient.title);

  //     // if (e.target.value === '') {
  //     //     this.setState({
  //     //         bookNumberValid: "form-control is-invalid",

  //     //     })
  //     // }
  // }

  getSchemeData = (data) => {
    PostApiCall.postRequest(
      {
        type: data,
      },
      "Get_Scheme_On_Type"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status == 200 || result.status == 201) {
          if (this.state.newClient.chitSchemeType == "Monthly") {
            this.setState({
              freqentChitfundData: obj.freqentChitfundData,
              booknumData2: obj.booknumData2,
              booknumData: obj.booknumData,
              freqentChitfundPriceData6: obj.freqentChitfundPriceData6,
              freqentChitfundPriceData7: obj.freqentChitfundPriceData7,
              freqentChitfundPriceData8: obj.freqentChitfundPriceData8,
              freqentChitfundPriceData9: obj.freqentChitfundPriceData9,
              freqentChitfundPriceData10: obj.freqentChitfundPriceData10,
            });
          } else {
            this.setState({
              freqentChitfundData: obj.freqentChitfundData,
              booknumData3: obj.booknumData3,
              freqentDurationData: obj.Dauration,
            });
          }
          this.setState({
            freqentChitfundPriceData: obj.freqentChitfundPriceData,
            freqentChitfundPriceData2: obj.freqentChitfundPriceData2,
            freqentChitfundPriceData3: obj.freqentChitfundPriceData3,
            freqentChitfundPriceData4: obj.freqentChitfundPriceData4,
            freqentChitfundPriceData5: obj.freqentChitfundPriceData5,
          });
          // window.location.reload();
        } else {
          Notiflix.Notify.Failure(obj.data);
        }
      })
    );
  };

  handleChitAmount = (e) => {
    let input_data = Object.assign({}, this.state.newClient);

    const fields = e.target.id;
    input_data[fields] = e.target.value;
    this.setState({
      chitAmountValid: "form-control is-valid",
      newClient: input_data,
    });
    //   console.log(e.target.value);

    if (e.target.value === "") {
      this.setState({
        chitAmountValid: "form-control is-invalid",
      });
    }
  };
  handlePaidMonth = (e) => {
    let input_data = Object.assign({}, this.state.newClient);

    const fields = e.target.id;
    input_data[fields] = e.target.value;
    // console.log(e.target.value);
    this.setState({
      newClient: input_data,
    });
    //   console.log(this.state.newClient.chitScheme);

    if (e.target.value === "") {
      this.setState({
        paidMonthsValid: "form-control is-invalid",
      });
    }
  };

  handleTitle = (e) => {
    let input_data = Object.assign({}, this.state.newClient);

    const fields = e.target.id;
    input_data[fields] = e.target.value;
    // console.log(e.target.value);
    this.setState({
      newClient: input_data,
    });
    //   console.log(this.state.newClient.chitScheme);

    if (e.target.value === "") {
      this.setState({
        titleValid: "form-control is-invalid",
      });
    }
  };

  handleDuration = (e) => {
    let input_data = Object.assign({}, this.state.newClient);

    const fields = e.target.id;
    input_data[fields] = e.target.value;
    // console.log(e.target.value);
    this.setState({
      durationValid: "form-control is-valid",
      newClient: input_data,
    });

    if (e.target.value === "") {
      this.setState({
        durationValid: "form-control is-invalid",
      });
    }
  };


  submitDataHandler = () => {
    if (
      this.state.newClient.chitScheme == "" &&
      this.state.newClient.title == "" &&
      this.state.newClient.accountNumber == "" &&
      this.state.newClient.chitAmount == "" &&
      this.state.newClient.duration == ""
    ) {
      this.setState({
        paidMonthsValid: "form-control is-invalid",
        userValid: "form-control is-invalid",
        chitAmountValid: "form-control is-invalid",
        durationValid: "form-control is-invalid",
        chitSchemeValid: "form-control is-invalid",
        bookNumberValid: "form-control is-invalid",
        accValid: "form-control is-invalid",
      });
    } else if (this.state.newClient.chitScheme == "") {
      this.setState({
        chitSchemeValid: "form-control is-invalid",
      });
    } else if (this.state.newClient.title == "") {
      Notiflix.Notify.Failure("Please select book number");
    } else if (this.state.newClient.accountNumber == "") {
      this.setState({
        accValid: "form-control is-invalid",
      });
    } else if (this.state.newClient.chitAmount == "") {
      Notiflix.Notify.Failure("Please select saving scheme amount");
    } else if (this.state.newClient.duration == "") {
      this.setState({
        durationValid: "form-control is-invalid",
      });
    } else if (
      this.state.newClient.chitScheme == "" ||
      this.state.newClient.title == "" ||
      this.state.newClient.chitAmount == "" ||
      this.state.newClient.duration == ""
    ) {
      return;
    } else {
      if (this.state.editOption === true) {
        // console.log('asdf');
        this.setState({
          paidMonthsValid: "form-control",
          userValid: "form-control",
          chitAmountValid: "form-control",
          durationValid: "form-control",
          chitSchemeValid: "form-control",
          accValid: "form-control",
          title: "form-control",
        });
        let { clients, arrIndex, newClient } = this.state;
        let new_data = Object.assign([], clients);
        new_data.splice(arrIndex, 1);
        new_data.push(newClient);

        this.setState(
          {
            clients: new_data,
            newClient: {
              accountNumber: " ",
              chitScheme: " ",
              chitSchemeType: " ",
              chitAmount: " ",
              duration: " ",
              user: " ",
              paidMonths: " ",
              title: " ",
            },
          },
        );
      } else {
        this.state.clients.push(this.state.newClient);
        this.setState({
          paidMonthsValid: "form-control",
          userValid: "form-control",
          chitAmountValid: "form-control",
          durationValid: "form-control",
          chitSchemeValid: "form-control",
          accValid: "form-control",
        });
        this.setState({
          showData: true,
          newClient: {
            accountNumber: "",
            chitScheme: "",
            chitAmount: "",
            duration: "",
            user: "",
            paidMonths: "",
            title: "",
          },
        });
      }
    }
  };

  editForm(value, index) {
    // console.log(value);
    this.setState({
      newClient: value,
      arrIndex: index,
      editOption: true,
    });
  }

  delForm = (index) => {
    //   console.log("hello")
    let new_data = Object.assign([], this.state.clients);
    new_data.splice(index, 1);
    // console.log(new_data)
    this.setState({
      clients: new_data,
    });
  };

  dataDropdown = (e) => {
    this.setState({
      dropdown: e.target.value,
    });
  };

  onSubmitChitschem(obj) {
    var det = localStorage.getItem("LoginDetail");
    var detail = JSON.parse(det);

    Notiflix.Loading.Dots("Please wait...");
    for (var i = 0; i < this.state.clients.length; i++) {
      PostApiCall.postRequest(
        {
          client: JSON.parse(JSON.stringify(obj.data[0])).ClientId,
          accountno:
            this.state.clients[i].title + this.state.clients[i].accountNumber,
          chitschema: this.state.clients[i].chitScheme,
          chitamount: this.state.clients[i].chitAmount,
          duration: this.state.clients[i].duration,
          user: this.state.clients[i].user,
          paidmonths: this.state.clients[i].paidMonths,
          updatedon: moment().format("YYYY-MM-DD"),
          updatedby: detail[0].fld_userid,
          clientStatus: "Approved",
          type: this.state.clients[i].chitSchemeType,
        },
        "Add_New_MonthlyClient_chitschema"
      ).then((result) =>
        result.json().then((obj) => {
          if (result.status == 200 || result.status == 201) {
            // console.log(obj)
            Notiflix.Loading.Remove();
            Notiflix.Notify.Success("Chit successfully added.");
            window.location.reload();
          } else {
            Notiflix.Loading.Remove();
            Notiflix.Notify.Failure(obj.data);
          }
        })
      );
    }
  }

  addClientBtn = () => {
    if (this.state.name == "") {
      Notiflix.Notify.Failure("Enter your Name");
    } else if (this.state.Email == "") {
      Notiflix.Notify.Failure("Enter your Email ");
    } else if (this.state.Mobile == "") {
      Notiflix.Notify.Failure("Enter Mobile Number");
    } else {
      Notiflix.Loading.Dots("Please wait...");

      var det = localStorage.getItem("LoginDetail");
      var detail = JSON.parse(det);
      PostApiCall.postRequest(
        {
          name: this.state.name,
          email: this.state.Email,
          mobile: this.state.Mobile,
          updatedon: moment().format("YYYY-MM-DD"),
          updatedby: detail[0].fld_userid,
          termsconditions: this.state.PermanentSame,
          clientStatus: "Approved",
        },
        "Add_New_Monthlyclient"
      ).then((result) =>
        result.json().then((obj) => {
          if (result.status == 200 || result.status == 201) {
            // console.log(obj)
            this.onSubmitChitschem(obj);
          } else {
            Notiflix.Loading.Remove();
            Notiflix.Notify.Failure(obj.data);
          }
        })
      );
    }
  };

  handleInputAccount = (e) => {
    let input_data = Object.assign({}, this.state.newClient);

    const fields = e.target.id;
    input_data[fields] = e.target.value;

    this.setState({
      accValid: "form-control is-valid",
      newClient: input_data,
    });
  };

  adressChange = (e) => {
    this.setState({
      address: e.target.value,
    });
  };

  landmarkChange = (e) => {
    this.setState({
      landmark: e.target.value,
    });
  };

  mobChange = (e) => {
    if (
      this.state.NumRegex.test(e.target.value) &&
      e.target.value.length <= 10
    ) {
      this.setState({
        Mobile: e.target.value,
      });
      if (e.target.value === "") {
        this.setState({
          MobileValid: "form-control is-invalid",
        });
      }
    }
  };
  nameChange = (e) => {
    this.setState({
      name: e.target.value,
    });

    if (e.target.value === "") {
      this.setState({
        NameValid: "form-control is-invalid",
      });
    }
  };
  usernameChange = (e) => {
    this.setState({
      username: e.target.value,
    });
  };
  emailChange = (e) => {
    this.setState({
      Email: e.target.value,
    });
    if (e.target.value === "") {
      this.setState({
        EmailValid: "form-control is-invalid",
      });
    }
  };

  render() {
    const userData = this.state.clients;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={this.props.t("Manage Clients")}
              breadcrumbItem={this.props.t("Add New Client")}
            />
            <AvForm className="needs-validation">
              <Card className="overflow-hidden">
                <div
                  className="maxXchange-bg-soft-pink"
                  style={{ background: "rgb(171, 61, 0)" }}
                >
                  <Row>
                    <Col xs="6">
                      <div className="maxXchange-text p-3">
                        <h5 className="maxXchange-text text-white">
                          Manage Clients
                        </h5>
                      </div>
                    </Col>
                  </Row>
                </div>

                <Card className="overflow-hidden">
                  <div
                    className="maxXchange-bg-soft-pink"
                    style={{ background: "#dfb65c" }}
                  >
                    <Row>
                      <Col xs="12">
                        <div className="maxXchange-text p-3">
                          <h5 className="maxXchange-text">Add New Client</h5>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <h4 className={"pt-2 pl-4 mb-0 mt-2"}>
                    Personal Information
                  </h4>
                  <p className={"ml-4"}>Enter Personal Information Of Client</p>
                  <CardBody>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label htmlFor="validationCustom01">
                            Name<span style={{ color: "red" }}>*</span>
                          </Label>
                          <AvField
                            name="Name"
                            placeholder="Enter Your Full Name"
                            type="text"
                            errorMessage="Enter Name"
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="validationCustom01"
                            value={this.state.name}
                            onChange={this.nameChange}
                          />
                        </FormGroup>
                      </Col>

                      <Col md="4">
                        <FormGroup>
                          <Label htmlFor="validationCustom03">
                            Email<span style={{ color: "red" }}>*</span>
                          </Label>
                          <AvField
                            name="Email"
                            placeholder="Eg: John@gmail.com"
                            type="email"
                            errorMessage=" Please provide a valid Email."
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="validationCustom03"
                            value={this.state.Email}
                            onChange={this.emailChange}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label htmlFor="validationCustom02">
                            Mobile Number<span style={{ color: "red" }}>*</span>
                          </Label>
                          <AvField
                            name="lastname"
                            placeholder="Enter 10 Digit Mobile Number"
                            type="number"
                            errorMessage="Enter Mobile Number"
                            className="form-control"
                            validate={{
                              required: { value: true },
                              minLength: {
                                value: 10,
                                errorMessage: "Enter 10 Digit Mobile Number.",
                              },
                              maxLength: {
                                value: 10,
                                errorMessage: "Enter 10 Digit Mobile Number.",
                              },
                            }}
                            id="validationCustom02"
                            value={this.state.Mobile}
                            onChange={this.mobChange}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                <Card className="overflow-hidden">
                  <div
                    className="maxXchange-bg-soft-pink"
                    style={{ background: "#dfb65c" }}
                  >
                    <Row>
                      <Col xs="12">
                        <div className="maxXchange-text p-3">
                          <h5 className="maxXchange-text">
                            Saving Scheme Details
                          </h5>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <CardBody>
                    <AvForm className="needs-validation">
                      <Row>
                        <Col md="2">
                          <FormGroup>
                            <Label htmlFor="validationCustom06">
                              Scheme Type{" "}
                              <span style={{ color: "red" }}>*</span>
                            </Label>
                            <select
                              class={
                                this.state.newClient.chitSchemeType !== ""
                                  ? "form-control is-valid"
                                  : "form-control"
                              }
                              id="title"
                              value={this.state.newClient.chitSchemeType}
                              onChange={(e) =>
                                this.setState(
                                  {
                                    newClient: {
                                      ...this.state.newClient,
                                      chitSchemeType: e.target.value,
                                    },
                                  },
                                  () =>
                                    this.getSchemeData(
                                      this.state.newClient.chitSchemeType
                                    )
                                )
                              }
                            >
                              <option selected value="" key="Select Book Type">
                                Select Book Type
                              </option>
                              {this.state.BookTypeData.map((data) => (
                                <option key={data.label} value={data.value}>
                                  {data.label}
                                </option>
                              ))}
                            </select>
                            <p
                              id="titleVal"
                              style={{ color: "#f46a6a", fontSize: "80%" }}
                            ></p>{" "}
                          </FormGroup>
                        </Col>
                        <Col md="4">
                          <FormGroup>
                            <Label htmlFor="validationCustom05">
                              Saving Scheme
                              <span style={{ color: "red" }}>*</span>
                            </Label>
                            <select
                              id="chitScheme"
                              className={`${this.state.chitSchemeValid}`}
                              value={this.state.newClient.chitScheme}
                              onChange={this.handleChitScheme}
                            >
                              {this.state.freqentChitfundData.map((data) => {
                                return (
                                  <option key={data.label} value={data.value}>
                                    {data.label}
                                  </option>
                                );
                              })}
                            </select>
                            {this.state.chitSchemeValid ==
                              "form-control is-invalid" && (
                                <div className="invalid-feedback">
                                  Select Your Chit Scheme{" "}
                                </div>
                              )}
                          </FormGroup>
                        </Col>

                        <Col md="2">
                          <FormGroup>
                            <Label htmlFor="validationCustom06">
                              Book Number{" "}
                              <span style={{ color: "red" }}>*</span>
                            </Label>
                            <select
                              class={
                                this.state.newClient.title !== ""
                                  ? "form-control is-valid"
                                  : "form-control"
                              }
                              id="title"
                              value={this.state.newClient.title}
                              onChange={this.handleTitle}
                            >
                              {this.state.newClient.chitScheme ==
                                "Thanga Mazhai" &&
                                this.state.booknumData2.map((data) => {
                                  return (
                                    <option key={data.label} value={data.value}>
                                      {data.label}
                                    </option>
                                  );
                                })}
                              {this.state.newClient.chitScheme ==
                                "My Gold Eleven" &&
                                this.state.booknumData.map((data) => {
                                  return (
                                    <option key={data.label} value={data.value}>
                                      {data.label}
                                    </option>
                                  );
                                })}
                              {this.state.newClient.chitScheme ==
                                "My Gold Flexi Plan" &&
                                this.state.booknumData3.map((data) => {
                                  return (
                                    <option key={data.label} value={data.value}>
                                      {data.label}
                                    </option>
                                  );
                                })}
                              {this.state.newClient.chitScheme == "" && (
                                <option key="Select Book Number" value="">
                                  Select Book Number
                                </option>
                              )}
                            </select>
                            <p
                              id="titleVal"
                              style={{ color: "#f46a6a", fontSize: "80%" }}
                            ></p>{" "}
                          </FormGroup>
                        </Col>

                        <Col md="2">
                          <FormGroup style={{ marginLeft: "-21px" }}>
                            <Label
                              htmlFor="validationCustom04"
                              style={{ color: "#fff" }}
                            >
                              Book Number
                            </Label>
                            <AvField
                              name="Account Number"
                              placeholder="Unique Book Number"
                              type="text"
                              pattern=""
                              errorMessage="Enter Book Number."
                              className={`${this.state.accValid}`}
                              validate={{
                                required: {
                                  value:
                                    this.state.accValid ===
                                      "form-control is-invalid"
                                      ? true
                                      : false,
                                },
                              }}
                              id="accountNumber"
                              value={this.state.newClient.accountNumber}
                              onChange={this.handleInputAccount}
                            />
                            {this.state.accValid ==
                              "form-control is-invalid" && (
                                <div className="invalid-feedback">
                                  Enter Correct Book Number
                                </div>
                              )}
                          </FormGroup>
                        </Col>
                        <Col
                          md="4"
                          style={{
                            display:
                              this.state.newClient.title == "MDA" ||
                                this.state.newClient.title == "MDB" ||
                                this.state.newClient.title == "MDC" ||
                                this.state.newClient.title == "MDD" ||
                                this.state.newClient.title == "MDE" ||
                                this.state.newClient.title == "GN" ||
                                this.state.newClient.title == "GO" ||
                                this.state.newClient.title == "GP" ||
                                this.state.newClient.title == "GQ"
                                ? ""
                                : "none",
                          }}
                        >
                          <FormGroup>
                            <Label htmlFor="validationCustom03">
                              Saving Scheme Amount
                              <span style={{ color: "red" }}>*</span>
                            </Label>
                            <select
                              class={
                                this.state.newClient.chitAmount !== ""
                                  ? "form-control is-valid"
                                  : "form-control"
                              }
                              id="chitAmount"
                              value={this.state.newClient.chitAmount}
                              onChange={this.handleChitAmount}
                            >
                              {this.state.newClient.title == "MDA" &&
                                this.state.freqentChitfundPriceData.map(
                                  (data) => {
                                    return (
                                      <option
                                        key={data.label}
                                        value={data.value}
                                      >
                                        {data.label}
                                      </option>
                                    );
                                  }
                                )}
                              {this.state.newClient.title == "MDB" &&
                                this.state.freqentChitfundPriceData2.map(
                                  (data) => {
                                    return (
                                      <option
                                        key={data.label}
                                        value={data.value}
                                      >
                                        {data.label}
                                      </option>
                                    );
                                  }
                                )}
                              {this.state.newClient.title == "MDC" &&
                                this.state.freqentChitfundPriceData3.map(
                                  (data) => {
                                    return (
                                      <option
                                        key={data.label}
                                        value={data.value}
                                      >
                                        {data.label}
                                      </option>
                                    );
                                  }
                                )}
                              {this.state.newClient.title == "MDD" &&
                                this.state.freqentChitfundPriceData4.map(
                                  (data) => {
                                    return (
                                      <option
                                        key={data.label}
                                        value={data.value}
                                      >
                                        {data.label}
                                      </option>
                                    );
                                  }
                                )}
                              {this.state.newClient.title == "MDE" &&
                                this.state.freqentChitfundPriceData5.map(
                                  (data) => {
                                    return (
                                      <option
                                        key={data.label}
                                        value={data.value}
                                      >
                                        {data.label}
                                      </option>
                                    );
                                  }
                                )}
                              {this.state.newClient.title == "GN" &&
                                this.state.freqentChitfundPriceData7.map(
                                  (data) => {
                                    return (
                                      <option
                                        key={data.label}
                                        value={data.value}
                                      >
                                        {data.label}
                                      </option>
                                    );
                                  }
                                )}
                              {this.state.newClient.title == "GO" &&
                                this.state.freqentChitfundPriceData8.map(
                                  (data) => {
                                    return (
                                      <option
                                        key={data.label}
                                        value={data.value}
                                      >
                                        {data.label}
                                      </option>
                                    );
                                  }
                                )}
                              {this.state.newClient.title == "GP" &&
                                this.state.freqentChitfundPriceData9.map(
                                  (data) => {
                                    return (
                                      <option
                                        key={data.label}
                                        value={data.value}
                                      >
                                        {data.label}
                                      </option>
                                    );
                                  }
                                )}
                              {this.state.newClient.title == "GQ" &&
                                this.state.freqentChitfundPriceData10.map(
                                  (data) => {
                                    return (
                                      <option
                                        key={data.label}
                                        value={data.value}
                                      >
                                        {data.label}
                                      </option>
                                    );
                                  }
                                )}
                            </select>
                            <p
                              id="chitAmount"
                              style={{ color: "#f46a6a", fontSize: "80%" }}
                            ></p>
                          </FormGroup>
                        </Col>
                        <Col
                          md="4"
                          style={{
                            display:
                              this.state.newClient.title == "GE" ||
                                this.state.newClient.title == "E"
                                ? ""
                                : "none",
                          }}
                        >
                          <FormGroup>
                            <Label htmlFor="validationCustom03">
                              Saving Scheme Amount
                              <span style={{ color: "red" }}>*</span>
                            </Label>
                            <select
                              class={
                                this.state.newClient.chitAmount !== ""
                                  ? "form-control is-valid"
                                  : "form-control"
                              }
                              id="chitAmount"
                              value={this.state.newClient.chitAmount}
                              onChange={this.handleChitAmount}
                            >
                              {this.state.newClient.title == "GE" ||
                                this.state.newClient.title == "E" ? (
                                this.state.freqentChitfundPriceData.map(
                                  (data) => {
                                    return (
                                      <option
                                        key={data.label}
                                        value={data.value}
                                      >
                                        {data.label}
                                      </option>
                                    );
                                  }
                                )
                              ) : (
                                <option>Select Scheme Amount</option>
                              )}
                            </select>
                            <p
                              id="chitAmount"
                              style={{ color: "#f46a6a", fontSize: "80%" }}
                            ></p>
                          </FormGroup>
                        </Col>

                        <Col
                          md="4"
                          style={{
                            display:
                              this.state.newClient.title == "GH" ||
                                this.state.newClient.title == "H" ||
                                this.state.newClient.title == "GHS"
                                ? ""
                                : "none",
                          }}
                        >
                          <FormGroup>
                            <Label htmlFor="validationCustom03">
                              Saving Scheme Amount
                              <span style={{ color: "red" }}>*</span>
                            </Label>
                            <select
                              class={
                                this.state.newClient.chitAmount !== ""
                                  ? "form-control is-valid"
                                  : "form-control"
                              }
                              id="chitAmount"
                              value={this.state.newClient.chitAmount}
                              onChange={this.handleChitAmount}
                            >
                              {this.state.freqentChitfundPriceData2.map(
                                (data) => {
                                  return (
                                    <option key={data.label} value={data.value}>
                                      {data.label}
                                    </option>
                                  );
                                }
                              )}
                            </select>
                            <p
                              id="chitAmount"
                              style={{ color: "#f46a6a", fontSize: "80%" }}
                            ></p>
                          </FormGroup>
                        </Col>

                        <Col
                          md="4"
                          style={{
                            display:
                              this.state.newClient.title == "GD" ? "" : "none",
                          }}
                        >
                          <FormGroup>
                            <Label htmlFor="validationCustom03">
                              Saving Scheme Amount
                              <span style={{ color: "red" }}>*</span>
                            </Label>
                            <select
                              class={
                                this.state.newClient.chitAmount !== ""
                                  ? "form-control is-valid"
                                  : "form-control"
                              }
                              id="chitAmount"
                              value={this.state.newClient.chitAmount}
                              onChange={this.handleChitAmount}
                            >
                              {this.state.freqentChitfundPriceData4.map(
                                (data) => {
                                  return (
                                    <option key={data.label} value={data.value}>
                                      {data.label}
                                    </option>
                                  );
                                }
                              )}
                            </select>
                            <p
                              id="chitAmount"
                              style={{ color: "#f46a6a", fontSize: "80%" }}
                            ></p>
                          </FormGroup>
                        </Col>

                        <Col
                          md="4"
                          style={{
                            display:
                              this.state.newClient.title == "K" ? "" : "none",
                          }}
                        >
                          <FormGroup>
                            <Label htmlFor="validationCustom03">
                              Saving Scheme Amount
                              <span style={{ color: "red" }}>*</span>
                            </Label>
                            <select
                              class={
                                this.state.newClient.chitAmount !== ""
                                  ? "form-control is-valid"
                                  : "form-control"
                              }
                              id="chitAmount"
                              value={this.state.newClient.chitAmount}
                              onChange={this.handleChitAmount}
                            >
                              {this.state.freqentChitfundPriceData3.map(
                                (data) => {
                                  return (
                                    <option key={data.label} value={data.value}>
                                      {data.label}
                                    </option>
                                  );
                                }
                              )}
                            </select>
                            <p
                              id="chitAmount"
                              style={{ color: "#f46a6a", fontSize: "80%" }}
                            ></p>
                          </FormGroup>
                        </Col>
                        <Col
                          md="4"
                          style={{
                            display:
                              this.state.newClient.title == "GL" ||
                                this.state.newClient.title == "L"
                                ? ""
                                : "none",
                          }}
                        >
                          <FormGroup>
                            <Label htmlFor="validationCustom03">
                              Saving Scheme Amount
                              <span style={{ color: "red" }}>*</span>
                            </Label>
                            <select
                              class={
                                this.state.newClient.chitAmount !== ""
                                  ? "form-control is-valid"
                                  : "form-control"
                              }
                              id="chitAmount"
                              value={this.state.newClient.chitAmount}
                              onChange={this.handleChitAmount}
                            >
                              {this.state.freqentChitfundPriceData5.map(
                                (data) => {
                                  return (
                                    <option key={data.label} value={data.value}>
                                      {data.label}
                                    </option>
                                  );
                                }
                              )}
                            </select>
                            <p
                              id="chitAmount"
                              style={{ color: "#f46a6a", fontSize: "80%" }}
                            ></p>
                          </FormGroup>
                        </Col>
                        <Col
                          md="4"
                          style={{
                            display:
                              this.state.newClient.title == "GM" ||
                                this.state.newClient.title == "M"
                                ? ""
                                : "none",
                          }}
                        >
                          <FormGroup>
                            <Label htmlFor="validationCustom03">
                              Saving Scheme Amount
                              <span style={{ color: "red" }}>*</span>
                            </Label>

                            <select
                              class={
                                this.state.newClient.chitAmount !== ""
                                  ? "form-control is-valid"
                                  : "form-control"
                              }
                              id="chitAmount"
                              value={this.state.newClient.chitAmount}
                              onChange={this.handleChitAmount}
                            >
                              {this.state.freqentChitfundPriceData6.map(
                                (data) => {
                                  return (
                                    <option key={data.label} value={data.value}>
                                      {data.label}
                                    </option>
                                  );
                                }
                              )}
                            </select>
                            <p
                              id="chitAmount"
                              style={{ color: "#f46a6a", fontSize: "80%" }}
                            ></p>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        {/* ============Duration=========== */}
                        <Col md="4">
                          <FormGroup>
                            <Label htmlFor="validationCustom04">
                              Duration<span style={{ color: "red" }}>*</span>
                            </Label>
                            <select
                              className={`${this.state.durationValid}`}
                              id="duration"
                              value={this.state.newClient.duration}
                              onChange={this.handleDuration}
                            >
                              {this.state.newClient.chitScheme ==
                                "Thanga Mazhai" &&
                                this.state.freqentDurationData.map((data) => {
                                  return (
                                    <option key={data.label} value={data.value}>
                                      {data.label}
                                    </option>
                                  );
                                })}

                              {this.state.newClient.chitScheme ==
                                "My Gold Eleven" &&
                                this.state.freqentDurationData2.map((data) => {
                                  return (
                                    <option key={data.label} value={data.value}>
                                      {data.label}
                                    </option>
                                  );
                                })}

                              {this.state.newClient.chitScheme ==
                                "My Gold Flexi Plan" &&
                                this.state.freqentDurationData3?.map((data) => {
                                  return (
                                    <option key={data.label} value={data.value}>
                                      {data.label}
                                    </option>
                                  );
                                })}

                              {this.state.newClient.chitScheme == "" && (
                                <option key="Select Duration" value="">
                                  Select Chit Duration
                                </option>
                              )}
                            </select>
                            {this.state.durationValid ==
                              "form-control is-invalid" && (
                                <div className="invalid-feedback">
                                  Select your Duration
                                </div>
                              )}
                          </FormGroup>
                        </Col>

                        {/* ==============USer========= */}
                        {/* <Col md="4">
                                                    <FormGroup>
                                                        <Label htmlFor="validationCustom05">User</Label>
                                                        <select className={`${this.state.userValid}`} id="user" value={this.state.newClient.user} name={'exiting_user'} onChange={this.handleUserInput}>
                                                            {this.state.freqentUserData.map(data => {
                                                                return <option key={data.label} value={data.value}>{data.label}</option>
                                                            })}
                                                        </select>
                                                        {this.state.userValid == 'form-control is-invalid' && (<div className='invalid-feedback'>Select User Type </div>)}

                                                    </FormGroup>
                                                </Col> */}

                        <Col
                          md="4"
                          className={
                            this.state.visiblity === true ? "d-none" : ""
                          }
                          style={{
                            display:
                              this.state.newClient.chitScheme ==
                                "Thanga Mazhai" &&
                                this.state.newClient.user == "Existing"
                                ? ""
                                : "none",
                          }}
                        >
                          <FormGroup>
                            <Label htmlFor="validationCustom05">
                              Paid months
                            </Label>
                            <select
                              class={
                                this.state.newClient.paidMonths !== ""
                                  ? "form-control is-valid"
                                  : "form-control"
                              }
                              id="paidMonths"
                              value={this.state.newClient.paidMonths}
                              onChange={this.handlePaidMonth}
                            >
                              {this.state.freqentMonthData.map((data) => {
                                return (
                                  <option key={data.label} value={data.value}>
                                    {data.label}
                                  </option>
                                );
                              })}
                            </select>
                            <p
                              id="paidMonthsrVal"
                              style={{ color: "#f46a6a", fontSize: "80%" }}
                            ></p>
                          </FormGroup>
                        </Col>
                        <Col
                          md="4"
                          className={
                            this.state.visiblity === true ? "d-none" : ""
                          }
                          style={{
                            display:
                              this.state.newClient.chitScheme ==
                                "My Gold Eleven"
                                ? ""
                                : "none",
                          }}
                        >
                          <FormGroup>
                            <Label htmlFor="validationCustom05">
                              Paid months
                            </Label>
                            <select
                              class={
                                this.state.newClient.paidMonths !== ""
                                  ? "form-control is-valid"
                                  : "form-control"
                              }
                              id="paidMonths"
                              value={this.state.newClient.paidMonths}
                              onChange={this.handlePaidMonth}
                            >
                              {this.state.freqentMonthData2.map((data) => {
                                return (
                                  <option key={data.label} value={data.value}>
                                    {data.label}
                                  </option>
                                );
                              })}
                            </select>
                            <p
                              id="paidMonthsrVal"
                              style={{ color: "#f46a6a", fontSize: "80%" }}
                            ></p>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <button
                          className={"btn ml-2"}
                          type="submit"
                          style={{
                            backgroundColor: "#880105",
                            color: "#e1b761",
                          }}
                          onClick={this.submitDataHandler}
                        >
                          Add Chit Scheme
                        </button>
                      </Row>
                    </AvForm>
                  </CardBody>
                </Card>

                <Card
                  className="overflow-hidden"
                  style={{
                    display: this.state.clients.length == 0 ? "d-none" : "",
                  }}
                >
                  <div
                    className="maxXchange-bg-soft-pink"
                    style={{ background: "#dfb65c" }}
                  >
                    <Row>
                      <Col xs="12">
                        <div className="maxXchange-text p-3">
                          <h5 className="maxXchange-text">
                            Saving Scheme List
                          </h5>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <CardBody>
                    <Table className="table table-centered table-nowrap">
                      <thead className="thead-light">
                        <tr>
                          <th>S no </th>
                          <th>Saving Scheme</th>
                          <th>Book No.</th>
                          <th>Saving Scheme Amount</th>
                          <th>Duration</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {userData &&
                          userData.map((value, index) => {
                            return (
                              <tr>
                                <td>{1 + index}</td>
                                <td>{value.chitScheme}</td>
                                <td>{value.title + value.accountNumber}</td>
                                <td>{value.chitAmount}</td>
                                <td>{value.duration}</td>

                                <td>
                                  <Link
                                    onClick={this.editForm.bind(
                                      this,
                                      value,
                                      index
                                    )}
                                    className="mr-3 text-primary"
                                  >
                                    <i
                                      className="mdi mdi-pencil font-size-18 mr-3"
                                      id="edittooltip"
                                    ></i>
                                    <UncontrolledTooltip
                                      placement="top"
                                      target="edittooltip"
                                    >
                                      Edit
                                    </UncontrolledTooltip>
                                  </Link>
                                  <Link
                                    onClick={this.delForm.bind(this, index)}
                                    className="text-danger"
                                  >
                                    <i
                                      className="mdi mdi-close font-size-18 mr-3"
                                      id="deletetooltip"
                                    ></i>
                                    <UncontrolledTooltip
                                      placement="top"
                                      target="deletetooltip"
                                    >
                                      Delete
                                    </UncontrolledTooltip>
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>

                <Card>
                  <CardBody className={"py-1"}>
                    <AvForm className="needs-validation">
                      <Row>
                        <Col md="6">
                          {/* <FormGroup className={"pt-1"}>
                              <div className="custom-control custom-checkbox pt-2">
                                  <input type="checkbox" class="form-check-input"
                                      checked={this.state.PermanentSame}
                                      onChange={() => {
                                          this.setState({
                                              PermanentSame: !this.state.PermanentSame
                                          })
                                      }}
                                  />
                                  <label class="form-check-label" for="exampleCheck1" style={{ verticalAlign: 'middle' }}>Agree to terms and conditions</lab
                              </div>
                          </FormGroup> */}
                        </Col>
                        <Col
                          md="6"
                          style={{ textAlign: "end", marginTop: ".2rem" }}
                        >
                          <button
                            className={"btn"}
                            type="submit"
                            style={{
                              backgroundColor: "#880105",
                              color: "#e1b761",
                              display:
                                this.state.clients.length != 0 ? "" : "none",
                            }}
                            onClick={this.addClientBtn}
                          >
                            Add Client
                          </button>
                          <button
                            className={"ml-2 btn"}
                            style={{
                              backgroundColor: "#880105",
                              color: "#e1b761",
                            }}
                            type="button"
                          >
                            Cancel
                          </button>
                        </Col>
                      </Row>
                    </AvForm>
                  </CardBody>
                </Card>
              </Card>
            </AvForm>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withNamespaces()(AddClients);
